export interface ITireDiscardItem {
  id?: number;
  created?: string;
  updated?: string;
  marking?: string;
  function?: string;
  state?: string;
  recap?: number;
  groove?: number;
  odometer?: number;
  performance?: number;
  lifeExpectancy?: number;
  lifePercent?: number;
  cpk?: number;
  dot?: string;
  totalCost?: number;
  initialGroove?: number;
  discardCost?: number;
  discardReason?: string;
  tireModel?: any;
  tireTreadModel?: any;
}

export interface IByManufacturerAndModel {
  tireManufacturer?: string;
  tireModel?: string;
  avgOdometer?: number;
}

export interface IByDiscardReason {
  reason?: string;
  count?: number;
}

export interface IByMonth {
  month?: string;
  avgLifePercent?: number;
  avgCost?: number;
  sumCost?: number;
}

export interface ITireDiscardDashboard {
  byManufacturerAndModel: IByManufacturerAndModel[];
  byDiscardReason: IByDiscardReason[];
  byMonth: IByMonth[];
}

export const defaultDashboardValue: Readonly<ITireDiscardDashboard> = {
  byManufacturerAndModel: [],
  byDiscardReason: [],
  byMonth: [],
};